import axios from 'axios/index'

const namespaced = true

const state = {
  categoriesList: null,
  categoryTypes: null,
  robots: null,
  serverTypes: null
}
const getters = {}
const actions = {
  getServerTypes ({ commit }) {
    axios({
      method: 'GET',
      url: '/api/private/v3.0/server-type/'
    })
      .then(response => {
        commit('setServerTypes', response.data)
        console.log(response.data)
      })
      .catch(error => {
        console.log(error.statusText)
      })
  },
  categoriesList ({ commit }) {
    axios({
      method: 'GET',
      url: '/api/private/v3.0/categories/'
    })
      .then(response => {
        commit('setCategoriesList', response.data)
        console.log(response.data)
      })
      .catch(error => {
        console.log(error.statusText)
      })
  },
  createFillBillCategory ({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/api/private/v3.0/categories/',
        data: data
      }).then(response => {
        console.log(response)
        dispatch('categoriesList')
        resolve(response)
      }).catch(error => {
        console.log(error.statusText)
        reject(error)
      })
    })
  },
  editFillBillCategory ({ dispatch }, data) {
    axios({
      method: 'PUT',
      url: '/api/private/v3.0/categories/' + data.id + '/',
      data: data.form
    })
      .then(response => {
        console.log(response.data)
        dispatch('categoriesList')
      })
      .catch(error => {
        console.log(error.statusText)
      })
  },
  deleteFillBillCategory ({ state }, data) {
    axios({
      method: 'POST',
      url: '/api/private/v3.0/categories/',
      data: data
    })
      .then(response => {
        console.log(response.data)
      })
      .catch(error => {
        console.log(error.statusText)
      })
  },
  loadCategoryTypes ({ commit }) {
    axios({
      method: 'GET',
      url: '/api/private/v3.0/category-types/'
    })
      .then(response => {
        commit('setCategoryTypes', response.data)
        console.log(response.data)
      })
      .catch(error => {
        console.log(error.statusText)
      })
  },
  loadRobots ({ commit }) {
    axios({
      method: 'GET',
      url: '/api/private/v3.0/robots/'
    })
      .then(response => {
        commit('setRobots', response.data)
        console.log(response.data)
      })
      .catch(error => {
        console.log(error.statusText)
      })
  }
}
const mutations = {
  setCategoriesList (state, data) {
    state.categoriesList = data.sort((a, b) => {
      return new Date(Date.parse(b.publication_date)) - new Date(Date.parse(a.publication_date))
    })
  },
  setCategoryTypes (state, data) {
    state.categoryTypes = data
  },
  setRobots (state, data) {
    state.robots = data
  },
  setServerTypes (state, data) {
    state.serverTypes = data
  }
}

export default {
  namespaced,
  state,
  actions,
  mutations,
  getters
}
